import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const WHATSAPP_BASE = "https://wa.me/919343920661";
export const WHATSAPP = `${WHATSAPP_BASE}?text=Hi%20Biswas3D%2C%20I%27d%20like%20to%20discuss%20a%20custom%203D%20print.`;
export const MAPS = "https://share.google/SQoN62DokMSE07CK6";
export const INSTAGRAM = "https://www.instagram.com/biswas3d/";
export const PHONE_DISPLAY = "+91 93439 20661";
